module.exports = __webpack_public_path__ + "assets/img/c196ac48558fb31199e9649a9953fde9.svg";